import classNames from 'classnames'
import React from 'react'

const Table = ({ title, ...props }) => {
    return (
        <div className="container mx-auto px-4">
            <div className="py-8">
                <div>
                    <h2 className="text-2xl font-semibold leading-tight">{title}</h2>
                </div>
                <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                    <div
                        className="inline-block min-w-full shadow-md rounded-lg overflow-hidden"
                    >
                        <table {...props} className={classNames("min-w-full leading-normal", props?.className)} />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Head = (props) => {
    return (
        <thead {...props} />
    )
}

const Body = (props) => {
    return (
        <tbody {...props} />
    )
}

const Row = (props) => {
    return (
        <tr {...props} />
    )
}

const Data = (props) => {
    return (
        <td {...props} className={classNames("px-5 py-5 border-b border-gray-200 bg-white text-sm", props?.className)} />
    )
}

const Header = (props) => {
    return (
        <th {...props} className={classNames("px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider", props?.className)} />
    )
}

Table.Head = Head
Table.Body = Body
Table.Row = Row
Table.Data = Data
Table.Header = Header

export default Table